module.exports = __webpack_public_path__ + "static/media/rac_only_logo_black.e8fc9779.svg";